import styled from 'styled-components'

export const Title = styled.div`
  color: #757575;
  font-size: 14px;
  font-weight: 700;
  padding: 16px 0 4px;
`

export const Info = styled.div`
  color: #213f68;
  font-size: 12px;
  padding-top: 8px;
  svg {
    margin: 0 6px 0 3px;
  }
`

export const Error = styled.div`
  color: #cf1322;
  font-size: 12px;
  padding-top: 4px;
  svg {
    margin: 0 6px 0 3px;
  }
`
